/* src/app/requests/request-detail/request-log/request-log.component.scss */
.log-item {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.log-item__description {
  color: #2f2f2f;
  font-size: 13px;
}
.log-item__timestamp {
  color: #717171;
  font-size: 13px;
  margin-left: auto;
}
@media (max-width: 930px) {
  .log-title {
    font-size: 1.8rem !important;
    font-weight: 500;
  }
}
/*# sourceMappingURL=request-log.component.css.map */
